import Editor from "./components/Editor"

export default {
  type: "string",
  name: "markdown",
  inputComponent: Editor
}
